<template>
  <div class="analytics-nav">
    <b-nav horizontal v-for="category in analyticsNav" :key="category.title">
      <localized-link
        class="analytics-nav__item"
        active-class="analytics-nav__item--active"
        v-for="link in category.links"
        v-if="!link.requiresPOS || hasPOSAccess"
        :key="link.title"
        :to="link.uri"
      >
        <a class="analytics-nav__item--normal">{{ $t(link.title) }}</a>
      </localized-link>

      <b-nav-item-dropdown
        class="analytics-nav__dropdown"
        toggle-class="analytics-nav__dropdown--toogle"
        right
      >
        <div slot="button-content">
          <i class="fi fi-list" aria-hidden="true" />
        </div>
        <b-dropdown-item
          v-for="_link in category.links"
          v-if="!_link.requiresPOS || hasPOSAccess"
          :key="`dropdown-${_link.title}`"
          @click="onClickDropDown(_link)"
        >
          {{ $t(_link.title) }}
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-nav>
  </div>
</template>

<script>
/* eslint-disable */
import LocalizedLink from "./LocalizedLink";
import { mapGetters } from "vuex";

export default {
  components: {
    LocalizedLink,
  },
  data() {
    return {
      analyticsNav: [
        {
          title: "analytics",
          links: [
            {
              title: this.$t("analytics.summary.nav_title"),
              uri: "/analytics/summary",
            },
            {
              title: "Transactions",
              uri: "/analytics/transactions",
            },
            {
              title: this.$t("analytics.occupancy.nav_title"),
              uri: "/analytics/occupancy",
            },
            {
              title: "Bookings",
              uri: "/analytics/bookings",
            },
            {
              title: "Arrivals",
              uri: "/analytics/arrivals",
            },
            {
              title: "Departures",
              uri: "/analytics/departures",
            },
            {
              title: "Sales",
              uri: "/analytics/sales",
              requiresPOS: true,
            },
            {
              title: "Product Mix",
              uri: "/analytics/products",
              requiresPOS: true,
            },
          ],
        },
      ],
    };
  },

  computed: {
    ...mapGetters("subscription", ["hasPOSAccess"]),
  },

  methods: {
    onClickDropDown(link) {
      const locale = this.$route.params.locale;

      if (this.to === "/") {
        return `/${locale}`;
      }

      let uri = `/${locale}/${link.uri.replace(/^\/|\/$/g, "")}`;

      this.$router.push({
        path: uri,
      });
    },
  },
};
</script>

<style lang="scss">
.analytics-nav {
  &__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__item--normal {
    padding: 15px;
    position: relative;
    color: #afafaf !important;
    transition: color 0.15s ease-in-out;

    &:hover {
      color: #404040;
    }
  }

  &__item--active {
    border-bottom: 2px solid #ef6341;
    background: #ffffff;

    & > .analytics-nav__item--normal {
      color: #404040 !important;
      padding-bottom: 13px;
      padding-top: 15px;
    }
  }

  &__dropdown {
    display: none;
    a {
      color: #404040 !important;
    }
  }
}

@media screen and (max-width: 1300px) {
  .analytics-nav {
    &__item {
      display: none;
    }

    &__item--active {
      display: flex !important;
    }

    &__dropdown {
      display: block;
      position: absolute;
      right: 250px;
      padding: 5px;

      .dropdown-menu-right.show {
        border: 1px solid #777;
        &:before {
          display: none;
        }

        .dropdown-item {
          &:hover {
            color: white !important;
          }
        }
      }

      &--toogle {
        padding: 4px 15px;
        font-size: 26px;

        &:after {
          display: none;
        }
      }
    }
  }
}
</style>
